/**
 * JSON Schema and prompt for the Work List response
 * Used with the Ask API to transform backend KPI data into work item format
 */

/**
 * Prompt that triggers the WorkList intent
 */
export const WORK_LIST_PROMPT = 'Get my assigned work items.'

/**
 * JSON Schema for the LLM to transform AssignedKpi data into work item format
 *
 * The LLM transforms backend fields:
 * - id ← ID
 * - title ← Title
 * - severity ← Derived from SLAState (critical if overdue, high if at risk)
 * - category ← Inferred from title content
 * - dueDate ← CurrentDueDate (ISO string), null if not set
 * - createdDate ← Use CurrentDueDate or current time
 */
export const WORK_LIST_RESPONSE_SCHEMA = {
  type: 'object',
  properties: {
    workItems: {
      type: 'array',
      items: {
        type: 'object',
        properties: {
          id: {
            type: 'string',
            description: 'Unique Id to identify this item in the system (not the external e.g. ADO work item Id)',
          },
          title: {
            type: 'string',
            description: 'Work item title from Title field',
          },
          severity: {
            type: 'string',
            enum: ['critical', 'high', 'medium', 'low'],
            description:
              'Derived from SLAState: "Overdue" -> critical, "AtRisk" -> high, otherwise medium or low',
          },
          category: {
            type: 'string',
            description:
              'Short category label (e.g., "Password Reset", "Network"). Infer from title content.',
          },
          dueDate: {
            type: ['string', 'null'],
            description: 'ISO 8601 date string from CurrentDueDate field, null if not set',
          },
          createdDate: {
            type: 'string',
            description: 'ISO 8601 date string, use CurrentDueDate or current time',
          },
        },
        required: ['id', 'title', 'severity', 'category', 'dueDate', 'createdDate'],
        additionalProperties: false,
      },
    },
  },
  required: ['workItems'],
  additionalProperties: false,
}
